import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { RequirementClient } from '@frontend/stock/api';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useRequirement:request': CustomEvent<string>;
    }
}

const REQUEST_REQUIREMENT_EVENT = 'useRequirement:request';
const STORAGE_KEY = 'REQUIREMENT_REQ';

export function requirementRequest(requirementId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_REQUIREMENT_EVENT, { detail: requirementId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function RequirementResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_REQUIREMENT_EVENT, EntityType.STOCK_REQUIREMENT, (ids) => RequirementClient.resolveRequirements(ids), props.dispatch);
    return <></>;
}
